// extracted by mini-css-extract-plugin
export default {"gray500":"#adb5bd","primaryColorBase":"#b40055","primaryColorLight":"#c80561","primaryColorLighter":"#ee2c88","primaryColorLightest":"#f077b0"};